import { render, staticRenderFns } from "./teamList.vue?vue&type=template&id=3a6b078c&scoped=true"
import script from "./teamList.vue?vue&type=script&lang=js"
export * from "./teamList.vue?vue&type=script&lang=js"
import style0 from "./teamList.vue?vue&type=style&index=0&id=3a6b078c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b078c",
  null
  
)

export default component.exports